import React from "react";

// CSS
import "../../../css/errors-success/errors.css";

class ErrorText extends React.PureComponent {
	render() {
		const { errors } = this.props;
		const { classes } = this.props;
		const { animate } = this.props;

		// If object, render each error seperately
		return typeof errors === "object" ? (
			Object.keys(errors).map(function(key) {
				return (
					<div
						key={key}
						className={
							`error` +
							(animate ? ` msg-animate` : ``) +
							(classes ? ` ` + classes : ``)
						}
					>
						{errors[key]}
					</div>
				);
			})
		) : (
			<div
				className={
					`error` + (animate ? ` msg-animate` : ``) + (classes ? ` ` + classes : ``)
				}
			>
				{errors}
			</div>
		);
	}
}

export default ErrorText;



// WEBPACK FOOTER //
// ./src/components/utils/error-success/ErrorText.js